<template>
    <div class="cps-main-page">
        <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item><i class="el-icon-s-home"></i>首页</el-breadcrumb-item>
            <el-breadcrumb-item>系统管理</el-breadcrumb-item>
            <el-breadcrumb-item>游戏喊话记录</el-breadcrumb-item>
        </el-breadcrumb>
        <el-divider></el-divider>

        <div class="page-content">
                <el-row @keyup.enter.native="loadData(1)">
                    <el-input v-model="query.sendUserId" size="small" placeholder="用户id"></el-input>
                    <el-input v-model="query.sendRoleName" size="small" placeholder="喊话用户角色"></el-input>
                    <el-input v-model="query.sendServerName" size="small" placeholder="喊话角色区服"></el-input>
<!--                    <el-select v-model="selectGame" size="small" placeholder="查询游戏">-->
<!--                      <el-option label="天使服" value="1"/>-->
<!--                      <el-option label="武魂觉醒" value="2"/>-->
<!--                    </el-select>-->
                    <el-select v-model="query.msgType" size="small" placeholder="消息类型">
                        <el-option label="普通消息" value="1"/>
                        <el-option label="官方通知" value="2"/>
                    </el-select>
                    <el-select v-model="query.msgStatus" size="small" placeholder="消息状态">
                        <el-option label="待审核" value="1"/>
                        <el-option label="已审核" value="2"/>
                    </el-select>
                    <el-button type="primary" size="small" @click="loadData(1)">查询</el-button>
                    <el-button size="small" @click="reset">重置</el-button>
                    <el-button v-if="this.groupId === '1'" type="primary" size="small" @click="dialogVisible = true">添加官方通知</el-button>
            </el-row>

            <el-table
                    class="cps-table-data"
                    :data="tableData"
                    size="small"
                    border
                    :height="height"
                    style="width: 100%"
                    id="rebateSetTable">
                <el-table-column
                        prop="shout_id"
                        label="消息id"
                        width="90">
                </el-table-column>
                <el-table-column
                        prop="send_user_id"
                        label="喊话用户id"
                        width="90">
                </el-table-column>
                <el-table-column
                        prop="send_role_name"
                        label="喊话用户角色"
                        width="160">
                </el-table-column>
                <el-table-column
                        prop="send_server_name"
                        label="喊话用户区服"
                        width="160">
                </el-table-column>
                <el-table-column
                        prop="msg"
                        label="消息"
                        width="400"
                        :show-overflow-tooltip="true">
                </el-table-column>
                <el-table-column
                        prop="msg_type"
                        label="消息类型"
                        width="120"
                        :formatter="msgTypeFormat">
                </el-table-column>
                <el-table-column
                        prop="msg_status"
                        label="消息状态"
                        width="120"
                        :formatter="msgStatusFormat">
                </el-table-column>
                <el-table-column
                        prop="send_time"
                        label="发送时间"
                        width="150">
                </el-table-column>
            </el-table>
            <el-pagination
                    class="cps-table-data"
                    @current-change="loadData"
                    background
                    :page-size="15"
                    :current-page="currentIndex"
                    layout="total,prev, pager, next"
                    :total="total">
            </el-pagination>

            <el-dialog
                    title="官方通知"
                    :visible.sync="dialogVisible"
                    :close-on-click-modal="false"
                    width="30%">
                    游戏名称：
                    <el-select
                            style="margin-bottom: 15px;"
                            size="small"
                            ref="selectGame"
                            v-model="game_id"
                            filterable
                            remote
                            reserve-keyword
                            placeholder="请输入游戏名称"
                            @change="handleSelect3"
                            :remote-method="loadGame"
                            @visible-change="cancelReadOnly"
                            >
                            <el-option
                                v-for="item in restaurants3"
                                :key="item.key"
                                :label="item.label"
                                :value="item.value">
                            </el-option>
                        </el-select>
                <el-input
                        type="textarea"
                        autosize
                        maxlength="100"
                        show-word-limit
                        resize="none"
                        :autosize="{ minRows: 4,maxRows: 4 }"
                        placeholder="请输入内容"
                        v-model.trim="msg">
                </el-input>
                <span slot="footer" class="dialog-footer">
                    <el-button @click="dialogClose">取 消</el-button>
                    <el-button type="primary" @click="inform">确 定</el-button>
                </span>
            </el-dialog>
            <el-dialog
                    title="武魂觉醒官方通知"
                    :visible.sync="dialog2Visible"
                    :close-on-click-modal="false"
                    width="30%">
                <el-input
                        type="textarea"
                        autosize
                        maxlength="100"
                        show-word-limit
                        resize="none"
                        :autosize="{ minRows: 4,maxRows: 4 }"
                        placeholder="请输入内容"
                        v-model.trim="msg2"
                        v-on:keyup.enter="informTwo">
                </el-input>
                <span slot="footer" class="dialog-footer">
                    <el-button @click="dialogCloseTwo">取 消</el-button>
                    <el-button type="primary" @click="informTwo">确 定</el-button>
                </span>
            </el-dialog>
        </div>
    </div>
</template>

<script>

    import {queryShoutRecord,sendInform,queryShout2Record,sendInformTwo, loadGame} from "@/api/request"

    export default {
        name: "shout",
        data(){
            return {
                game_id: '',
                restaurants3: [],
                tableData:[],
                currentIndex: 1,
                height: window.innerHeight - 220,
                total: 0,
                dialogVisible: false,
                dialog2Visible: false,
                msg: '',
                msg2: '',
                groupId:'',
                selectGame: '',
                query:{
                    sendUserId: '',
                    sendRoleName: '',
                    sendServerName: '',
                    msgType: '',
                    msgStatus: '',
                }
            }
        },
        mounted() {
            this.loadData(1);
            let user = JSON.parse(localStorage.getItem("userInfo"));
            this.groupId = user.groupId;
        },
        methods:{
            handleSelect3(item){
                this.game_id = item;
            },
            loadGame(query){
                if (query !== '') {
                    let me = this;
                    loadGame(query).then(res => {
                        me.restaurants3 = [];
                        res.data.data.forEach(function (e) {
                            let item = {}
                            item.key = e.game_id
                            item.value = e.game_id
                            item.label = e.game_name
                            me.restaurants3.push(item)
                        })
                    })
                }
            },
            cancelReadOnly(value){
                this.$nextTick(() => {
                    if (!value) {
                    const {selectGame} = this.$refs;
                    const input = selectGame.$el.querySelector(".el-input__inner");
                    input.removeAttribute("readonly");
                    this.$refs.selectGame.blur();
                    }
                });
            },
            loadData(index){
                let params = {
                    pageNo: index,
                    pageSize: 15,
                    params: this.query
                }
                if(this.selectGame === "1" || this.selectGame === ""){
                    queryShoutRecord(params).then( res => {
                        this.tableData = res.data.list;
                        this.total = res.data.total;
                        this.currentIndex = index;
                    })
                }else if(this.selectGame === "2"){
                    queryShout2Record(params).then( res => {
                        this.tableData = res.data.list;
                        this.total = res.data.total;
                        this.currentIndex = index;
                    })
                }
            },
            reset(){
                this.query = {
                    sendUserId: '',
                    sendRoleName: '',
                    sendServerName: '',
                    msgType: '',
                    msgStatus: ''
                }
                this.selectGame = '';
            },
            inform(){
                if (this.game_id == null || this.game_id === '') {
                    this.$message.warning("请输入择要发送通知的游戏！");
                    return;
                }
                if(this.msg != null && this.msg != ''){
                    let param = {
                        "msg" : this.msg,
                        "gameId":this.game_id
                    }
                    sendInform(param).then( res => {
                        if(res.data.success){
                            this.msg = '';
                            this.$message.success("操作成功");
                            this.dialogVisible = false;
                            this.loadData(1);
                        } else {
                            this.$message.error(res.data.error.message);
                        }
                    }).catch(() => {})
                }else {
                    this.$message.warning("请输入需要发送的通知！")
                }
            },
            dialogClose(){
                this.dialogVisible = false;
                this.msg = '';
                this.game_id = '';
                this.restaurants3 = [];
                this.$message('取消输入');
            },
            informTwo(){
              if(this.msg2 != null && this.msg2 != ''){
                let param = {
                  "msg" : this.msg2
                }
                sendInformTwo(param).then( res => {
                  if(res.data.success){
                    this.msg2 = '';
                    this.$message.success("操作成功");
                    this.dialog2Visible = false;
                    this.loadData(1);
                  } else {
                    this.$message.error(res.data.error.message);
                  }
                }).catch(() => {})
              }else {
                this.$message.warning("请输入需要发送的通知！")
              }
            },
            dialogCloseTwo(){
              this.dialog2Visible = false;
              this.msg2 = '';
              this.$message('取消输入');
            },
            msgTypeFormat(row, column, cellValue){  //消息类型(1：普通消息，2：官方通知)
                let str = '';
                if(cellValue === 1){
                    str = '普通消息';
                }else if(cellValue === 2){
                    str = '官方通知';
                }
                return str;
            },
            msgStatusFormat(row, column, cellValue){ //消息状态(1：待审核，2：已审核)
                let str = '';
                if(cellValue === 1){
                    str = '待审核';
                }else if(cellValue === 2){
                    str = '已审核';
                }
                return str;
            }
        }
    }
</script>

<style scoped>

</style>